import { render, staticRenderFns } from "./faqs.html?vue&type=template&id=da91da8a&scoped=true&"
import script from "./faqs.js?vue&type=script&lang=js&"
export * from "./faqs.js?vue&type=script&lang=js&"
import style0 from "./faqs.scss?vue&type=style&index=0&id=da91da8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da91da8a",
  null
  
)

export default component.exports